import { useMemo } from 'react';
import classes from '../ReportResult/ReportResult.module.css';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';
import RealPlayQualifiedDataHelper from 'features/realplays/RealPlayQualifiedData.helper';
import Strengths from '../ReportResult/Strengths';
import Improvements from '../ReportResult/Improvements';
import Feedback from '../ReportResult/Feedback';
import ImprovementGraph from '../ReportResult/ImprovementGraph';

const NewRealPlayRightSection = ({ isLoadingResponse, handleSeek = () => {} }) => {
  const { assignment_uuid, selectedScenario } = RealPlayRecordDataHelper();

  const { rating_criteria, status_ai, feedback, summary } = RealPlayQualifiedDataHelper();

  const overallRating = useMemo(() => {
    if (!rating_criteria || rating_criteria?.length === 0) return 0;
    const initialValue = 0;
    const sum = rating_criteria.reduce(
      (accumulator, currentValue) => accumulator + currentValue?.rating,
      initialValue
    );
    let avg = sum / rating_criteria?.length;

    return sum === 0 ? 0 : avg;
  }, [rating_criteria]);

  return (
    <div className={classes.right}>
      {/* Ratings & Why You Got Them*/}
      {/* Improvement*/}
      <ImprovementGraph
        assignment_uuid={assignment_uuid}
        response_uuid={selectedScenario?.response?.uuid}
        mode={'review'}
        overall={overallRating}
      />
      {/*Overall Feedback*/}
      <Feedback
        title="Read this as your coaching summary"
        feedback={feedback}
        status_ai={status_ai}
        isLoadingResponse={isLoadingResponse}
      />
      <Strengths
        title="What to double down on"
        summary={summary}
        isLoadingResponse={isLoadingResponse}
        handleSeek={handleSeek}
      />
      {/* Practice & Improve */}
      <Improvements
        title="What to fix next"
        summary={summary}
        isLoadingResponse={isLoadingResponse}
      />
    </div>
  );
};
export default NewRealPlayRightSection;
